import React from "react";
import Filters from "../../components/filters/Filters";
import CustomersTable from "../../components/customers/CustomersTable";

const Customers = () => {
  return (
    <section>
      <Filters searchPlaceholder="name" section="customers" />
      <CustomersTable />
    </section>
  );
};

export default Customers;
